import { CountryReducer } from './country.reducer';

export const reducers = CountryReducer;
